import React, { useState, useEffect } from "react";

import { Dialog, DialogActions, DialogContent, DialogTitle,
  Slide, Table, TableBody,
  TableContainer, TableHead, TableRow,
  CircularProgress, Paper, Button, Chip,
  TableSortLabel, Snackbar, IconButton, Backdrop
} from "@mui/material";

import ManageHistoryIcon from '@mui/icons-material/ManageHistory';

import {
  TableButton,
  StyledTableRow,
  StyledTableCell,
  StyleTableSortLabel,
} from "../../SXStyle";

import {
  asignarLicencia,
  verMisLicencias,
} from "../../service/apiService";

import { useAppDispatch, useAppSelector } from "../../provider/app/hooks";
import { setItems as setLicenseItem } from "../../provider/Slice/LicenceSlice";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMisLicencias({ open, setOpen, setSnackbar, registroSeleccionado }) {
  const dispatch = useAppDispatch();

  const licencias = useAppSelector((state) => state.StoreLicencias.data);
  
  const cacheUsuario = JSON.parse(localStorage.getItem("sesionIniciada"));

  const [data, setData] = useState([]);

  //order columns
  const [order, setOrder] = useState("asc"); // "asc" o "desc"
  const [orderBy, setOrderBy] = useState("type"); // columna ordenada

  //loader
  const [openLoader, setOpenLoader] = useState(false);

  //licencias
  const [licenciasAsignadas, setLicenciasAsignadas] = useState([]);

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedData = React.useMemo(
    () => [...(data || [])].sort(getComparator(order, orderBy)),
    [data, order, orderBy]
  );

  useEffect(() => {
    if(open)
    loadData();
  }, [registroSeleccionado, open]);

  //carga las licencias asignadas y el listado de usuarios
  const loadData = async() => {
    try
    {
      setOpenLoader(true);

      if (registroSeleccionado !== null) 
      {
        await verLicenciasxUsuario(registroSeleccionado.id);
        setData(licencias);
      }
    }
    catch(ex)
    {
      console.log("ex")
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  }

  //ve las licencias que tiene el usuario seleccionado
  const verLicenciasxUsuario = async (id) => {
    const response = await verMisLicencias(id);
    setLicenciasAsignadas(response.data);
  };

  const recuperarLicenciaUsuario = (idLicencia) => {
    if (licenciasAsignadas.licencias.length > 0) {
      let result = licenciasAsignadas.licencias.filter(
        (item) => item.user === registroSeleccionado.id && item.id === idLicencia
      );
      return result.length > 0;
    }
    return false;
  };

  //asigna o quita licencia dado el caso
  const asignarLicenciaUsuario = async (idLicencia) => {
    try 
    {
      setOpenLoader(true);

      let dataToSend = {
        user: registroSeleccionado.id,
        license: idLicencia,
        status: 1,
        assigned_by: cacheUsuario.id,
      };
      const response = await asignarLicencia(dataToSend);
      setSnackbar({ message: response?.message, open: true });

      //recarga todo el listado de licencias
      dispatch(setLicenseItem(response.data));

      //recarga el listado de licencia especifica
      await loadData();
    } 
    catch (ex) {
      console.log({ ex });
      setSnackbar({
        message: "Algo ha salido mal , intentelo de nuevo",
        open: true,
      });
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  };

  return (
    <React.Fragment>
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            width: "100%",
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
            maxHeight: "500px"
          },
        }}
      >
        <DialogTitle>
          <div className="flex w-full">
            <p className="text-white font-bold text-sm mt-2 ml-2"> Licencias asignadas a: {registroSeleccionado?.fullname} </p>
              <div className="ml-auto cursor-pointer"> 
                <ManageHistoryIcon className="text-blanco" sx={{fontSize: "28px" }}/>
              </div>
          </div>
        </DialogTitle>

        <DialogContent>
          {/* Tabla */}
            <div>
              {openLoader ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <CircularProgress sx={{ color: "#cc9737" }} />
                </div>
              ) : (
                <TableContainer
                    component={Paper}
                    sx={{ maxHeight: "350px", width: "100%", marginTop: "20px" }}
                  >
                  <Table aria-label="customized table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">
                      
                        </StyledTableCell>
                                          
                        <StyledTableCell
                          align="left"
                          sortDirection={orderBy === "name" ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === "name"}
                            direction={orderBy === "name" ? order : "asc"}
                            onClick={() => handleRequestSort("name")}
                            sx={{ ...StyleTableSortLabel, width: "250px" }}
                          >
                            <p className="ml-8"> Licencia </p>
                          </TableSortLabel>
                        </StyledTableCell>

                        <StyledTableCell
                          align="left"
                          sortDirection={orderBy === "name" ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === "name"}
                            direction={orderBy === "name" ? order : "asc"}
                            onClick={() => handleRequestSort("name")}
                            sx={StyleTableSortLabel}
                          >
                            Reservado
                          </TableSortLabel>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {sortedData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                      
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <div className="flex ml-5">
                              <span className="mr-5"> {row.name}</span> 
                              <Chip 
                                label="Válido"
                                className="ml-3 mt-[-5px]"
                                sx={{
                                  backgroundColor: row.state == "1" ? "#248f7a" : "#cb9636", 
                                  color: "white",
                                  fontWeight: "bold",
                                }}
                              />
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Button
                              variant="contained"
                              sx={{
                                ...TableButton,
                                color: "white",
                                backgroundColor: recuperarLicenciaUsuario(row.id)
                                  ? "green"
                                  : "gray",
                              }}
                              onClick={() => asignarLicenciaUsuario(row.id)}
                            >
                              Reservar
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cerrar </p>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogMisLicencias;
